export const SET_HETH_LATEST_STAT = 'SET_HETH_LATEST_STAT'
